@if (showIconSelector) {
  <div class="icon-selector-container">
    <div style="text-align: right; margin: 8px 8px 0 0; cursor: pointer" (click)="showIconSelector = false"><i class="fa fa-times" style="color: gray"></i></div>
    <div class="row">
      @for (fileName of iconFileNames; track fileName) {
        <div class="col-xs-3">
          <div class="icon">
            <img [src]="'/assets/img/markets/'+fileName" width="130px" style="cursor: pointer; margin-bottom: 24px;" (click)="setSerieIcon(fileName)">
          </div>
        </div>
      }
    </div>
  </div>
}
